import { ErrorStateMatcher } from '@angular/material/core';
import { FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { Injectable } from "@angular/core";

@Injectable()
export class CustomErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        // return (control.invalid && (control.dirty || control.touched || isSubmitted));
        // return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
        return control.dirty && form.invalid;
    }
}
